module.exports = __webpack_public_path__ + "static/media/16.2a188136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/16.jpg
// module id = 84
// module chunks = 0